import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'

export const BIND_TOKEN = 'bind_token' // token key
export const TOKEN_KEY = 'token' // token key
export const USER_ID_KEY = 'user_id' // token key

//判断是否是微信浏览器的函数
export const isWeiXin = function(){
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    return true;
  }else{
    return false;
  }
}
// 设置绑定手机token
export const setBindToken = (bind_token) => {
  Cookies.set(BIND_TOKEN, bind_token, { expires: 1 })
}

// 获取绑定手机token
export const getBindToken = () => {
  const bind_token = Cookies.get(BIND_TOKEN)
  if (bind_token) return bind_token
  else return false
}

// 删除绑定手机token
export const removeBindToken = () => {
  const bind_token = Cookies.remove(BIND_TOKEN)
  if (bind_token) return bind_token
  else return false
}

// 设置token
export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: 1 })
}

// 获取token
export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}

// 删除token
export const removeToken = () => {
  const token = Cookies.remove(TOKEN_KEY)
  if (token) return token
  else return false
}

// 设置user_id
export const setUserId = (user_id) => {
  Cookies.set(USER_ID_KEY, user_id, { expires: 1 })
}

// 获取user_id
export const getUserId = () => {
  const user_id = Cookies.get(USER_ID_KEY)
  if (user_id) return user_id
  else return false
}

// 删除user_id
export const removeUserId = () => {
  const user_id = Cookies.remove(USER_ID_KEY)
  if (user_id) return user_id
  else return false
}

// AES加密, 返回String类型
export function AESEncrypted(string) {
  const key = CryptoJS.enc.Utf8.parse('J3s2RdALJqzVtndB')
  const iv = CryptoJS.enc.Utf8.parse('I49cCU6CvsF6M013')

  const encryptedData = CryptoJS.AES.encrypt(string, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  return CryptoJS.enc.Base64.stringify(encryptedData.ciphertext)
}

// 生成随机唯一数
export function guid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0,
			v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}